var messages = {
  perPage: ' Item/Page',
  prevPage: 'Prev page',
  nextPage: 'Next page',
  prevFivePage: '5 pages forward',
  nextFivePage: '5 pages backward',
  sum: 'Total ',
  oneUnit: '',
  goTo: 'Go to',
  page: 'Page'
};
export default messages;